export default "__VITE_ASSET__f3Gk56_I__"